module.exports = __webpack_public_path__ + "cf6008d396082c09c3dd4907de9f3941.woff2";